import CryptoJS from "crypto-js";

// Encryption function
export const encryptData = (data, secretKey) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};

// Decryption function
export const decryptData = (ciphertext, secretKey) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
  try {
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption failed:", error,secretKey);
    return null;
  }
};

const setItem = (key,state) => {
    try {
      if (key === "uiLanguage") {
        localStorage.setItem(key, state);
        return;
      }
      
      const encryptedState = encryptData(state, key);
      localStorage.setItem(key, encryptedState);

    } catch (error) {
      console.error("Error saving state:", error,key);
    }
  };
  
const getItem = (key) => {
    try {
      if (key === "uiLanguage") {
        return localStorage.getItem(key);
      }
      const encryptedState = localStorage.getItem(key);
      if (!encryptedState || encryptedState === undefined) return null;
      return decryptData(encryptedState, key);
    } catch (error) {
      console.error("Error loading state:", error,key);
      return undefined;
    }
  };

const clearLocalStoragePreservingLanguage = () => {
  const selectedUiLanguage = localStorage.getItem("uiLanguage");
  localStorage.clear();

  setItem("language", "de");

  if (selectedUiLanguage) {
    localStorage.setItem("uiLanguage", selectedUiLanguage);
  }
};

  export { setItem, getItem, clearLocalStoragePreservingLanguage}


  
